import React from 'react';

export const ActivityRoute = React.lazy(() =>
  import(/* webpackChunkName: "activity" */ './ActivityRoute'),
);
